/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2 Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 * Also http://anmar.eu.org/projects/jssha2/
 */

/*
 * Configurable variables. You may need to tweak these to be compatible with
 * the server-side, but the defaults work in most cases.
 */
var hexcase = 0; /* hex output format. 0 - lowercase; 1 - uppercase    */
var b64pad = ""; /* base-64 pad character. "=" for strict RFC compliance  */

/*
 * These are the functions you'll usually want to call
 * They take string arguments and return either hex or base-64 encoded strings
 */
function hex_sha256(s) {
	return rstr2hex(rstr_sha256(str2rstr_utf8(s)));
}

function b64_sha256(s) {
	return rstr2b64(rstr_sha256(str2rstr_utf8(s)));
}

function any_sha256(s, e) {
	return rstr2any(rstr_sha256(str2rstr_utf8(s)), e);
}

function hex_hmac_sha256(k, d) {
	return rstr2hex(rstr_hmac_sha256(str2rstr_utf8(k), str2rstr_utf8(d)));
}

function b64_hmac_sha256(k, d) {
	return rstr2b64(rstr_hmac_sha256(str2rstr_utf8(k), str2rstr_utf8(d)));
}

function any_hmac_sha256(k, d, e) {
	return rstr2any(rstr_hmac_sha256(str2rstr_utf8(k), str2rstr_utf8(d)), e);
}

/*
 * Perform a simple self-test to see if the VM is working
 */
function sha256_vm_test() {
	return hex_sha256("abc").toLowerCase() ==
		"ba7816bf8f01cfea414140de5dae2223b00361a396177a9cb410ff61f20015ad";
}

/*
 * Calculate the sha256 of a raw string
 */
function rstr_sha256(s) {
	return binb2rstr(binb_sha256(rstr2binb(s), s.length * 8));
}

/*
 * Calculate the HMAC-sha256 of a key and some data (raw strings)
 */
function rstr_hmac_sha256(key, data) {
	var bkey = rstr2binb(key);
	if (bkey.length > 16) bkey = binb_sha256(bkey, key.length * 8);

	var ipad = Array(16),
		opad = Array(16);
	for (var i = 0; i < 16; i++) {
		ipad[i] = bkey[i] ^ 0x36363636;
		opad[i] = bkey[i] ^ 0x5C5C5C5C;
	}

	var hash = binb_sha256(ipad.concat(rstr2binb(data)), 512 + data.length * 8);
	return binb2rstr(binb_sha256(opad.concat(hash), 512 + 256));
}

/*
 * Convert a raw string to a hex string
 */
function rstr2hex(input) {
	try {
		hexcase
	} catch (e) {
		hexcase = 0;
	}
	var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
	var output = "";
	var x;
	for (var i = 0; i < input.length; i++) {
		x = input.charCodeAt(i);
		output += hex_tab.charAt((x >>> 4) & 0x0F) +
			hex_tab.charAt(x & 0x0F);
	}
	return output;
}

/*
 * Convert a raw string to a base-64 string
 */
function rstr2b64(input) {
	try {
		b64pad
	} catch (e) {
		b64pad = '';
	}
	var tab = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	var output = "";
	var len = input.length;
	for (var i = 0; i < len; i += 3) {
		var triplet = (input.charCodeAt(i) << 16) |
			(i + 1 < len ? input.charCodeAt(i + 1) << 8 : 0) |
			(i + 2 < len ? input.charCodeAt(i + 2) : 0);
		for (var j = 0; j < 4; j++) {
			if (i * 8 + j * 6 > input.length * 8) output += b64pad;
			else output += tab.charAt((triplet >>> 6 * (3 - j)) & 0x3F);
		}
	}
	return output;
}

/*
 * Convert a raw string to an arbitrary string encoding
 */
function rstr2any(input, encoding) {
	var divisor = encoding.length;
	var remainders = Array();
	var i, q, x, quotient;

	/* Convert to an array of 16-bit big-endian values, forming the dividend */
	var dividend = Array(Math.ceil(input.length / 2));
	for (i = 0; i < dividend.length; i++) {
		dividend[i] = (input.charCodeAt(i * 2) << 8) | input.charCodeAt(i * 2 + 1);
	}

	/*
	 * Repeatedly perform a long division. The binary array forms the dividend,
	 * the length of the encoding is the divisor. Once computed, the quotient
	 * forms the dividend for the next step. We stop when the dividend is zero.
	 * All remainders are stored for later use.
	 */
	while (dividend.length > 0) {
		quotient = Array();
		x = 0;
		for (i = 0; i < dividend.length; i++) {
			x = (x << 16) + dividend[i];
			q = Math.floor(x / divisor);
			x -= q * divisor;
			if (quotient.length > 0 || q > 0)
				quotient[quotient.length] = q;
		}
		remainders[remainders.length] = x;
		dividend = quotient;
	}

	/* Convert the remainders to the output string */
	var output = "";
	for (i = remainders.length - 1; i >= 0; i--)
		output += encoding.charAt(remainders[i]);

	/* Append leading zero equivalents */
	var full_length = Math.ceil(input.length * 8 /
		(Math.log(encoding.length) / Math.log(2)))
	for (i = output.length; i < full_length; i++)
		output = encoding[0] + output;

	return output;
}

/*
 * Encode a string as utf-8.
 * For efficiency, this assumes the input is valid utf-16.
 */
function str2rstr_utf8(input) {
	var output = "";
	var i = -1;
	var x, y;

	while (++i < input.length) {
		/* Decode utf-16 surrogate pairs */
		x = input.charCodeAt(i);
		y = i + 1 < input.length ? input.charCodeAt(i + 1) : 0;
		if (0xD800 <= x && x <= 0xDBFF && 0xDC00 <= y && y <= 0xDFFF) {
			x = 0x10000 + ((x & 0x03FF) << 10) + (y & 0x03FF);
			i++;
		}

		/* Encode output as utf-8 */
		if (x <= 0x7F)
			output += String.fromCharCode(x);
		else if (x <= 0x7FF)
			output += String.fromCharCode(0xC0 | ((x >>> 6) & 0x1F),
				0x80 | (x & 0x3F));
		else if (x <= 0xFFFF)
			output += String.fromCharCode(0xE0 | ((x >>> 12) & 0x0F),
				0x80 | ((x >>> 6) & 0x3F),
				0x80 | (x & 0x3F));
		else if (x <= 0x1FFFFF)
			output += String.fromCharCode(0xF0 | ((x >>> 18) & 0x07),
				0x80 | ((x >>> 12) & 0x3F),
				0x80 | ((x >>> 6) & 0x3F),
				0x80 | (x & 0x3F));
	}
	return output;
}

/*
 * Encode a string as utf-16
 */
function str2rstr_utf16le(input) {
	var output = "";
	for (var i = 0; i < input.length; i++)
		output += String.fromCharCode(input.charCodeAt(i) & 0xFF,
			(input.charCodeAt(i) >>> 8) & 0xFF);
	return output;
}

function str2rstr_utf16be(input) {
	var output = "";
	for (var i = 0; i < input.length; i++)
		output += String.fromCharCode((input.charCodeAt(i) >>> 8) & 0xFF,
			input.charCodeAt(i) & 0xFF);
	return output;
}

/*
 * Convert a raw string to an array of big-endian words
 * Characters >255 have their high-byte silently ignored.
 */
function rstr2binb(input) {
	var output = Array(input.length >> 2);
	for (var i = 0; i < output.length; i++)
		output[i] = 0;
	for (var i = 0; i < input.length * 8; i += 8)
		output[i >> 5] |= (input.charCodeAt(i / 8) & 0xFF) << (24 - i % 32);
	return output;
}

/*
 * Convert an array of big-endian words to a string
 */
function binb2rstr(input) {
	var output = "";
	for (var i = 0; i < input.length * 32; i += 8)
		output += String.fromCharCode((input[i >> 5] >>> (24 - i % 32)) & 0xFF);
	return output;
}

/*
 * Main sha256 function, with its support functions
 */
function sha256_S(X, n) {
	return (X >>> n) | (X << (32 - n));
}

function sha256_R(X, n) {
	return (X >>> n);
}

function sha256_Ch(x, y, z) {
	return ((x & y) ^ ((~x) & z));
}

function sha256_Maj(x, y, z) {
	return ((x & y) ^ (x & z) ^ (y & z));
}

function sha256_Sigma0256(x) {
	return (sha256_S(x, 2) ^ sha256_S(x, 13) ^ sha256_S(x, 22));
}

function sha256_Sigma1256(x) {
	return (sha256_S(x, 6) ^ sha256_S(x, 11) ^ sha256_S(x, 25));
}

function sha256_Gamma0256(x) {
	return (sha256_S(x, 7) ^ sha256_S(x, 18) ^ sha256_R(x, 3));
}

function sha256_Gamma1256(x) {
	return (sha256_S(x, 17) ^ sha256_S(x, 19) ^ sha256_R(x, 10));
}

function sha256_Sigma0512(x) {
	return (sha256_S(x, 28) ^ sha256_S(x, 34) ^ sha256_S(x, 39));
}

function sha256_Sigma1512(x) {
	return (sha256_S(x, 14) ^ sha256_S(x, 18) ^ sha256_S(x, 41));
}

function sha256_Gamma0512(x) {
	return (sha256_S(x, 1) ^ sha256_S(x, 8) ^ sha256_R(x, 7));
}

function sha256_Gamma1512(x) {
	return (sha256_S(x, 19) ^ sha256_S(x, 61) ^ sha256_R(x, 6));
}

var sha256_K = new Array(
	1116352408, 1899447441, -1245643825, -373957723, 961987163, 1508970993, -1841331548, -1424204075, -670586216, 310598401, 607225278, 1426881987,
	1925078388, -2132889090, -1680079193, -1046744716, -459576895, -272742522,
	264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, -1740746414, -1473132947, -1341970488, -1084653625, -958395405, -710438585,
	113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291,
	1695183700, 1986661051, -2117940946, -1838011259, -1564481375, -1474664885, -1035236496, -949202525, -778901479, -694614492, -200395387, 275423344,
	430227734, 506948616, 659060556, 883997877, 958139571, 1322822218,
	1537002063, 1747873779, 1955562222, 2024104815, -2067236844, -1933114872, -1866530822, -1538233109, -1090935817, -965641998
);

function binb_sha256(m, l) {
	var HASH = new Array(1779033703, -1150833019, 1013904242, -1521486534,
		1359893119, -1694144372, 528734635, 1541459225);
	var W = new Array(64);
	var a, b, c, d, e, f, g, h;
	var i, j, T1, T2;

	/* append padding */
	m[l >> 5] |= 0x80 << (24 - l % 32);
	m[((l + 64 >> 9) << 4) + 15] = l;

	for (i = 0; i < m.length; i += 16) {
		a = HASH[0];
		b = HASH[1];
		c = HASH[2];
		d = HASH[3];
		e = HASH[4];
		f = HASH[5];
		g = HASH[6];
		h = HASH[7];

		for (j = 0; j < 64; j++) {
			if (j < 16) W[j] = m[j + i];
			else W[j] = safe_add(safe_add(safe_add(sha256_Gamma1256(W[j - 2]), W[j - 7]),
				sha256_Gamma0256(W[j - 15])), W[j - 16]);

			T1 = safe_add(safe_add(safe_add(safe_add(h, sha256_Sigma1256(e)), sha256_Ch(e, f, g)),
				sha256_K[j]), W[j]);
			T2 = safe_add(sha256_Sigma0256(a), sha256_Maj(a, b, c));
			h = g;
			g = f;
			f = e;
			e = safe_add(d, T1);
			d = c;
			c = b;
			b = a;
			a = safe_add(T1, T2);
		}

		HASH[0] = safe_add(a, HASH[0]);
		HASH[1] = safe_add(b, HASH[1]);
		HASH[2] = safe_add(c, HASH[2]);
		HASH[3] = safe_add(d, HASH[3]);
		HASH[4] = safe_add(e, HASH[4]);
		HASH[5] = safe_add(f, HASH[5]);
		HASH[6] = safe_add(g, HASH[6]);
		HASH[7] = safe_add(h, HASH[7]);
	}
	return HASH;
}

function safe_add(x, y) {
	var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	return (msw << 16) | (lsw & 0xFFFF);
}

//获取cookie
function getCookie(name) {
	var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	return (arr = document.cookie.match(reg)) ? unescape(arr[2]) : null;
}

//写入cookies
function setCookie(name, value, days) {
	var Days = days || 1;
	var exp = new Date();
	exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
	document.cookie = name + "=" + escape(value) + ";path=/;expires=" + exp.toGMTString();
}

//清除cookie
function clearCookie(name) {
	setCookie(name, "", -1);
}

//platform
function platform(context) {
	return 2;
}

//channel_code
function channel_code(context) {
	return "web"; //TEA_MARKET
}

// 获取系统类型
function getSysName() {
	return "TEA_B2C";
}

// device_id
function getDeviceId(context) {
	function uuid() {
		var s = [];
		var hexDigits = "0123456789abcdef";
		for (var i = 0; i < 36; i++) {
			s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
		}
		s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
		s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
		s[8] = s[13] = s[18] = s[23] = "-";

		var uuid = s.join("");
		return uuid;
	}
	var deviceId = getCookie('DEVICEID');
	setCookie('DEVICEID', deviceId, 365);
	if (!deviceId) {
		deviceId = uuid();
		setCookie('DEVICEID', deviceId, 365);
	}
	return deviceId;
}
//弹窗提示
function toast(text, time, cb) {
	var body = window.document.body;
	var toast = document.createElement("div");
	toast.className = 'nlx_toast';
	body.appendChild(toast);
	toast.innerHTML = text;
	toast.style.backgroundColor = 'rgba(0,0,0,.6)';
	setTimeout(function () {
		if (typeof (cb) == 'function') {
			cb();
		}
		body.removeChild(toast);
	}, time);
}

function deepClone(data) {
	var type = (typeof data == 'object') ? (Array.isArray(data) ? 'array' : 'object') : "other";
	var obj;
	if (type === 'array') {
		obj = [];
	} else if (type === 'object') {
		obj = {};
	} else {
		//不再具有下一层次
		return data;
	}
	if (type === 'array') {
		for (var i = 0, len = data.length; i < len; i++) {
			obj.push(deepClone(data[i]));
		}
	} else if (type === 'object') {

		for (var key in data) {
			obj[key] = deepClone(data[key]);
		}
	}
	return obj;
}

function isInArray(arr, str) {
	var result = false;
	arr.forEach((element) => {
		if (element == str) {
			result = true;
		}
	})
	return result;
}
/* 参数是秒 */
function changeTime(time) {
	let timeShow;
	var days = parseInt(time / (60 * 60 * 24));
	var hours = parseInt((time % (60 * 60 * 24)) / (60 * 60));
	var minutes = parseInt((time % (60 * 60)) / (60));
	var seconds = parseInt(time % (60));
	hours = hours < 10 ? ('0' + hours) : hours;
	minutes = minutes < 10 ? ('0' + minutes) : minutes;
	seconds = seconds < 10 && seconds >= 1 ? ('0' + seconds) : seconds;
	timeShow = days + "天" + hours + "时" + minutes + "分" + seconds + "秒";
	return timeShow;

}

//图片预览
function imgShow(e, url) {
	let body = window.document.body;
	let previewBox = document.createElement("div");
	let imgUrl = url || e.path[0].currentSrc;
	let top = e.y
	let left = e.x
	previewBox.className = 'imgShow';
	previewBox.innerHTML = `<img src="${imgUrl}" class="previewImg" style="top:${top}px;left:${left}px;"/>`
	body.appendChild(previewBox);
	setTimeout(() => {
		document.getElementsByClassName('previewImg')[0].classList.add("active")
	}, 1)
	document.getElementsByClassName('imgShow')[0].onclick = function () {
		body.removeChild(this);
	}
}


/*
* 函数定义
* 入口参数data,平行数组
* key，id字段
* parentKey，父字段
* map, 需要将原始属性名称转换为什么名称
*/
function treeUtil(data, key, parentKey, parentKeyValue, map) {
	this.data = data;
	this.key = key;
	this.parentKey = parentKey;
	this.parentKeyValue = parentKeyValue;
	this.treeParentKey = parentKey;   //parentKey要转换成什么属性名称
	this.treeKey = key;               //key要转换成什么属性名称
	this.map = map;
	if (map) {
		if (map[key]) this.treeKey = map[key];
	}
	this.toTree = function () {
		var data = this.data;
		var pos = {};
		var tree = [];
		var i = 0;
		while (data.length != 0) {
			if (data[i][this.parentKey] == this.parentKeyValue || !data[i][this.parentKey] || data[i][this.parentKey] <= 0) {
				var _temp = this.copy(data[i]);
				tree.push(_temp);
				pos[data[i][this.key]] = [tree.length - 1];
				data.splice(i, 1);
				i--;
			} else {
				var posArr = pos[data[i][this.parentKey]];
				if (posArr != undefined) {
					var obj = tree[posArr[0]];
					for (var j = 1; j < posArr.length; j++) {
						obj = obj.children[posArr[j]];
					}
					var _temp = this.copy(data[i]);
					obj.children.push(_temp);
					pos[data[i][this.key]] = posArr.concat([obj.children.length - 1]);
					data.splice(i, 1);
					i--;
				} else {
					console.error(`有脏数据或者排序不对`);
				}
			}
			i++;
			if (i > data.length - 1) {
				i = 0;
			}
		}
		return tree;
	}
	this.copy = function (item) {
		var _temp = {
			children: []
		};
		_temp[this.treeKey] = item[this.key];
		for (var _index in item) {
			if (_index != this.key && _index != this.parentKey) {
				var _property = item[_index];
				if ((!!this.map) && this.map[_index])
					_temp[this.map[_index]] = _property;
				else
					_temp[_index] = _property;
			}
		}
		return _temp;
	}
}


//百度富文本的按钮基础配置项
const baiduButton = [[
	'fullscreen', 'source', '|', 'undo', 'redo', '|',
	'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'superscript', 'subscript', 'removeformat', 'formatmatch', 'autotypeset', 'blockquote', 'pasteplain', '|', 'forecolor', 'backcolor', 'insertorderedlist', 'insertunorderedlist', 'selectall', 'cleardoc', '|',
	'rowspacingtop', 'rowspacingbottom', 'lineheight', '|',
	'customstyle', 'paragraph', 'fontfamily', 'fontsize', '|',
	'directionalityltr', 'directionalityrtl', 'indent', '|',
	'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|', 'touppercase', 'tolowercase', '|',
	'link', 'unlink', 'anchor', '|', 'imagenone', 'imageleft', 'imageright', 'imagecenter', '|',
	'emotion', 'scrawl', 'insertvideo', 'music', 'attachment', 'map', 'gmap', 'insertframe', 'insertcode', 'webapp', 'pagebreak', 'template', 'background', '|',
	'horizontal', 'date', 'time', 'spechars', 'snapscreen', 'wordimage', '|',
	'inserttable', 'deletetable', 'insertparagraphbeforetable', 'insertrow', 'deleterow', 'insertcol', 'deletecol', 'mergecells', 'mergeright', 'mergedown', 'splittocells', 'splittorows', 'splittocols', 'charts', '|',
	'print', 'preview', 'searchreplace', 'drafts', 'help'
]]

//在时间对象原型上加方法
Date.prototype.Format = function (formatStr) {
	var str = formatStr;
	var Week = ['日', '一', '二', '三', '四', '五', '六'];

	str = str.replace(/yyyy|YYYY/, this.getFullYear());
	str = str.replace(/yy|YY/, (this.getYear() % 100) > 9 ? (this.getYear() % 100).toString() : '0' + (this.getYear() % 100));

	str = str.replace(/MM/, this.getMonth() > 9 ? this.getMonth().toString() : '0' + this.getMonth());
	str = str.replace(/M/g, this.getMonth());

	str = str.replace(/w|W/g, Week[this.getDay()]);

	str = str.replace(/dd|DD/, this.getDate() > 9 ? this.getDate().toString() : '0' + this.getDate());
	str = str.replace(/d|D/g, this.getDate());

	str = str.replace(/hh|HH/, this.getHours() > 9 ? this.getHours().toString() : '0' + this.getHours());
	str = str.replace(/h|H/g, this.getHours());
	str = str.replace(/mm/, this.getMinutes() > 9 ? this.getMinutes().toString() : '0' + this.getMinutes());
	str = str.replace(/m/g, this.getMinutes());

	str = str.replace(/ss|SS/, this.getSeconds() > 9 ? this.getSeconds().toString() : '0' + this.getSeconds());
	str = str.replace(/s|S/g, this.getSeconds());

	return str;
}

/**
 * 指定日期格式化
 * @param date 日期
 * @param fmt 格式
 * @returns {*}
 */
function dateFormats(date, fmt) {
  let o = {
    "M+": date.getMonth() + 1, //月份
    "d+": date.getDate(), //日
    "h+": date.getHours(), //小时
    "m+": date.getMinutes(), //分
    "s+": date.getSeconds(), //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    "S": date.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
};

function comeToArr(data, tag, id, flag) {//id:唯一标识 flag:是判断条件 tag：子数组名称
	let arr = [];
	function aa(ownData, tag, id, flag) {
		ownData.forEach(el => {
			if (el[flag]) {
				arr.push(el[id] + '')
				if (el[tag] && el[tag].length != 0) {
					aa(el[tag], tag, id, flag);
				}
			}
		})
	}
	aa(data, tag, id, flag)
	return arr
}

var authorId_until = [2, 3, 401, 'OATXL', 'OAYYZX', 'OASY', 'ERROR', 'LOGIN', 'MEMBERDETAIL', 'NOTICEDETAIL', 'APPDETAILTWO', 'APPDETAIL', 'TEST', '应用中心默认永久权限'];


var native = {
	onDownloadStart: function (url, mimetype) {
		var fun = function (url, mimetype) {
			if (!window) return;
			window.helper && window.helper.onDownloadStart(url, mimetype);
		}
		if (window) {
			fun(url, mimetype);
		}
	}
}
function whichOneInArr(arr, childTag, tag, tagIndex, tag2) {//tag标记key，tagIndex查找标识,子数组，目前只能是二维数组
	let indexParent = [];
	arr.forEach((el, index) => {
		if (el[tag] == tagIndex) {
			indexParent = [index];
			return;
		} else if (el[tag2] == "detail") {
			el[childTag].forEach((el2, index2) => {
				if (el2[tag] == tagIndex) {
					indexParent = [index, index2];
					return;
				}
			});
		}
	});
	return indexParent;
}

function downLoadFile(blob, fileName) {
	fileName = fileName || '未命名';
	if (navigator.msSaveBlob) {
		return navigator.msSaveBlob(blob, fileName);
	} else {
		const objectUrl = URL.createObjectURL(blob);
		const link = document.createElement("a");
		link.href = objectUrl;
		link.setAttribute("download", fileName);
		document.body.appendChild(link);
		link.click();
	}
}

function findUnidById(arr, type, id, childTag, flag) {//通过id和type 找到树结构中的unid,childTag是子数组名称
	let findArr = [];
	childFn(arr, type, id, childTag, flag);
	function childFn(array, type, id, childTag, flag) {
		for (let index = 0; index < array.length; index++) {
			const element = array[index];
			if (element.type == type && element.aid == id) {
				if(flag){
					element.disabled=true;
				}
				findArr.push(element);
			}else if(element[childTag]&&element[childTag].length!=0){
				childFn(element[childTag],type,id,childTag,flag)
			}else{
				if(flag){
					element.disabled=false;
				}
			}
		}
	}

	return findArr;
}

function findUnidById2(arr, type, id, childTag, flag) {//通过id和type 找到树结构中的unid,childTag是子数组名称
	let findArr = [];
	childFn(arr, type, id, childTag, flag);
	function childFn(array, type, id, childTag, flag) {
		for (let index = 0; index < array.length; index++) {
			const element = array[index];
			if (element.type == type && element.id == id) {
				if(flag){
					element.disabled=true;
				}
				findArr.push(element);
			}else if(element[childTag]&&element[childTag].length!=0){
				childFn(element[childTag],type,id,childTag,flag)
			}else{
				if(flag){
					element.disabled=false;
				}
			}
		}
	}

	return findArr;
}
function findUnidByCode(arr, type, code, childTag,flag) {//通过id和type 找到树结构中的unid,childTag是子数组名称
	let findArr=[];
	childFn(arr, type, code, childTag,flag);
	function childFn(array,type,code,childTag,flag) {
		for (let index = 0; index < array.length; index++) {
			const element = array[index];
			if (element.type != type && element.acode == code) {
				if(flag){
					element.disabled=true;
				}
				findArr.push(element);
			}else if(element[childTag]&&element[childTag].length!=0){
				childFn(element[childTag],type,code,childTag,flag)
			}else{
				if(flag){
					element.disabled=false;
				}
			}
		}
	}

	return findArr;
}

function isEmpty(obj) {
  if (typeof obj == "undefined" || obj == null || obj == "") {
    return true;
  } else {
    return false;
  }
}

/**
 * 校验密码,6-16位,大小写字母,数字和特殊字符
 * @param pwd
 */
function verifyPwd(pwd) {
	var regex = new RegExp('^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{6,20}$');
	if (!regex.test(pwd)) {
	  return true
	} else {
	  return false
	}
  }


var utils = {
	sha256: hex_sha256,
	getSysName: getSysName,
	getCookie: getCookie,
	clearCookie: clearCookie,
	setCookie: setCookie,
	platform: platform,
	channel_code: channel_code,
	getDeviceId: getDeviceId,
	toast: toast,
	deepClone: deepClone,
	isInArray: isInArray,
	changeTime: changeTime,
	imgShow,
	treeUtil: treeUtil,
	baiduButton: baiduButton,
	comeToArr: comeToArr,
	authorId_until,
	native: native,
	whichOneInArr,
	downLoadFile: downLoadFile,
  findUnidById,
  findUnidById2,
  isEmpty,
  dateFormats,
	findUnidByCode,
	verifyPwd
};

export default utils;



// WEBPACK FOOTER //
// ./src/utils/index.js